export default __webpack_public_path__ + "static/media/vectorCima.d6a664c5.png";